import { render, staticRenderFns } from "./haibao.vue?vue&type=template&id=ddb2dade&"
import script from "./haibao.vue?vue&type=script&lang=js&"
export * from "./haibao.vue?vue&type=script&lang=js&"
import style0 from "./haibao.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports